const enTranslation = {
  Architecture: 'Architecture',
  GovernmentofCanada: 'Government of Canada',
  QuantumDocumentation: 'Quantum Documentation',
  Tagline: 'Excellent applications need awesome architectures. This is Quantum.',
  TopIntro: 'Quantum is a decentralized microservice architecutre created by the Digital Enablement Division within the Government of Canada for our digital products. Everything you need to create fast, responsive, and secure digital products can be found in our solution design.  Quantum will always be free, open, collaborative and evolving.',
  MainCTA: 'Get started',
  GithubLink: 'Find us on GitHub',
  AboutQuantum: 'About Quantum',
  SimpleFlexible: 'Simple and flexible',
  SimpleFlexibleParagraph: 'Provides all necessary elements without being restrictive. The microservice template and front-end template are lightweight and can be adapted to suit any product.',
  Reusable: 'Re-usable',
  ReusableParagraph: 'Suits a variety of needs. All components and principles are generic enough to be applied to a wide range of digital products.',
  Diverse: 'Diverse',
  DiverseParagraph: 'Covers a variety of needs and types of products. Quantum follows common Open Source standards like GraphQL, Open ID, and AMQP',
  Open: 'Open',
  OpenParagraph: 'To anyone who wishes to use it. All of Quantum’s code is open source, and all other frameworks used within are free and Open Source.',
  BottomText: 'Do you not fall into any of the roles above? Do you have ideas on how we can improve? The Aurora team is always looking for contributors to help us make our design system even more awesome for all content creators.',
  LearnMore: 'Learn more',
  Components: 'Components',
  Overview: 'Overview',
  Identity: 'Identity',
  Content: 'Content',
  Data: 'Data',
  Download: 'Download',
  'COPY CODE': 'COPY CODE',
  Copy: 'Copy',
  'Copied!': 'Copied!',
  'SHOW CODE': 'SHOW CODE',
  'HIDE CODE': 'HIDE CODE',
  search_no_results: 'No results were found.',
  search_start_searching: 'Start searching...',
  MainNavigation: 'Main Navigation',
  SubNavigation: 'Sub Navigation',
  Reply: 'Reply',
  Pressed: 'Pressed',
  Design: 'Design',
  CanadaSymbol: 'Symbol of the Government of Canada',
  tooltip: 'Tooltip',
  tooltipexample: 'More information here',
};

export default enTranslation;



// WEBPACK FOOTER //
// ./src/i18n/locales/en/translation.js